module.exports = __webpack_public_path__ + "static/media/LogicWedge6_4_drag_3.3ac1f865.png";